// extracted by mini-css-extract-plugin
export default {"text":"SmsTemplates_text__VboAu","tags":"SmsTemplates_tags__eWyDo"};